var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookieIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.567 6.97a2.742 2.742 0 0 0 3.902 0 2.8 2.8 0 0 0 0-3.936 2.742 2.742 0 0 0-3.902 0 2.8 2.8 0 0 0 0 3.935zM20.3 21.59a2.742 2.742 0 0 1-3.902 0 2.8 2.8 0 0 1 0-3.935 2.742 2.742 0 0 1 3.902 0 2.8 2.8 0 0 1 0 3.936zm-6.85-6.91a2.742 2.742 0 0 1-3.901 0 2.8 2.8 0 0 1 0-3.936 2.742 2.742 0 0 1 3.902 0 2.8 2.8 0 0 1 0 3.936zm-2.266 7.644a1.661 1.661 0 0 1-2.363 0 1.696 1.696 0 0 1 0-2.384 1.661 1.661 0 0 1 2.363 0 1.696 1.696 0 0 1 0 2.384zm15.468-6.701a4.567 4.567 0 0 1-4.217-1.254 4.662 4.662 0 0 1-1.318-3.82.566.566 0 0 0-.623-.63 4.57 4.57 0 0 1-3.787-1.329 4.66 4.66 0 0 1-1.243-4.253.573.573 0 0 0-.553-.682 12.586 12.586 0 0 0-9.704 4.262C.98 12.678.924 19.992 5.083 24.81a12.601 12.601 0 0 0 18.538.664 12.802 12.802 0 0 0 3.706-9.291c-.007-.357-.33-.633-.676-.559zm1.946-6.855a1.371 1.371 0 0 1-1.951 0 1.4 1.4 0 0 1 0-1.968 1.371 1.371 0 0 1 1.95 0 1.4 1.4 0 0 1 0 1.968z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieIcon);
export default __webpack_public_path__ + "static/media/cookie-icon.7ec54c38944eabb11982238c190045d0.svg";
export { ForwardRef as ReactComponent };